import React from 'react';

const certificationLogos = [
  { id: 1, name: 'CMMI SVC ML3', type: 'cmmi' },
  { id: 2, name: 'CMMI DEV ML3', type: 'cmmi' },
  { id: 3, name: 'SBA 8(a)', type: 'sba' },
  { id: 4, name: 'MBE Certified', type: 'mbe' },
  { id: 5, name: 'ISO 9001', type: 'iso' },
  { id: 6, name: 'ISO 20000', type: 'iso' },
  { id: 7, name: 'ISO 27001', type: 'iso' },
];

const CertificationBadge = ({ cert }) => {
  const getStyle = () => {
    switch (cert.type) {
      case 'cmmi':
        return (
          <div className="bg-white border-2 border-blue-600 rounded-lg p-3 w-32 h-20 flex flex-col items-center justify-center shadow-sm hover:shadow-md transition-shadow">
            <span className="text-blue-600 font-bold text-lg tracking-wider">CMMI</span>
            <span className="text-[10px] text-blue-500">APPRAISED</span>
            <span className="text-[8px] text-gray-500 mt-1">Exp. May 28, 2025</span>
          </div>
        );
      case 'sba':
        return (
          <div className="bg-slate-800 rounded-lg p-3 w-24 h-20 flex flex-col items-center justify-center shadow-sm hover:shadow-md transition-shadow">
            <span className="text-white font-bold text-xl">SBA</span>
            <span className="text-orange-400 text-[8px]">U.S. Small Business</span>
            <span className="text-blue-400 text-[10px] font-semibold">8 (a) CERTIFIED</span>
          </div>
        );
      case 'mbe':
        return (
          <div className="bg-white border-2 border-blue-600 rounded-lg p-3 w-24 h-20 flex flex-col items-center justify-center shadow-sm hover:shadow-md transition-shadow">
            <span className="text-blue-600 font-bold text-xl">MBE</span>
            <span className="text-[8px] text-gray-600">CERTIFIED</span>
          </div>
        );
      case 'iso':
        return (
          <div className="bg-white border-2 border-gray-300 rounded-lg p-3 w-24 h-20 flex flex-col items-center justify-center shadow-sm hover:shadow-md transition-shadow">
            <span className="text-gray-700 font-bold text-sm">ISO</span>
            <span className="text-gray-900 font-bold text-lg">{cert.name.split(' ')[1]}</span>
          </div>
        );
      default:
        return null;
    }
  };

  return getStyle();
};

const CertificationsSection = () => {
  return (
    <div className="bg-gradient-to-r from-orange-300 via-orange-200 to-blue-200 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center items-center gap-6">
          {certificationLogos.map((cert) => (
            <CertificationBadge key={cert.id} cert={cert} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CertificationsSection;
